'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';

// Selected tab management atom - stores selected tabs by ID
export const selectedTabAtom = atom<Record<string, string>>({}) as WritableAtom<
  Record<string, string>,
  [Record<string, string>],
  void
>;

export const setSelectedTabAtom = atom(null, (get, set, id: string, tab: string | null) => {
  const current = get(selectedTabAtom);
  if (tab === null) {
    const { [id]: _, ...rest } = current;
    set(selectedTabAtom, rest);
  } else {
    set(selectedTabAtom, { ...current, [id]: tab });
  }
});

export function useSelectedTab(id: string, defaultValue?: string) {
  const [selectedTabMap] = useAtom(selectedTabAtom);
  const setSelectedTab = useSetAtom(setSelectedTabAtom);
  const selectedTab = selectedTabMap[id] ?? defaultValue ?? null;

  return {
    selectedTab,
    selectedTabMap,
    setSelectedTab: (value: string | null) => setSelectedTab(id, value),
  };
}
